module.exports = __webpack_public_path__ + "img/landing_box38.12e15e69.jpg";